import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Box, Column, Row, TextButton, Typography, useMediaQueries } from 'seagull';
import { ArrowSolidRight, Bulb } from 'seagull/icons';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import styles from './IntroContentDesktop.module.scss';
const VIDEO_ID = 'zbXQwOdZYyk';
const VIDEO_THUMBNAIL_URL = "https://img.youtube.com/vi/".concat(VIDEO_ID, "/hqdefault.jpg");
const introStepTextsPath = 'pages.vendorOnboarding.introStep';
export const IntroContentDesktop = (param)=>{
    let { testIds, onPlay, onSkip } = param;
    const { t } = useLocaleKeys(introStepTextsPath);
    const firstName = useStore(selectors.user.firstName);
    const { smallerThanTablet: isTablet } = useMediaQueries();
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx(styles.root, isTablet && styles.tablet),
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                className: clsx(styles.leftColumn, isTablet && styles.tablet),
                children: [
                    /*#__PURE__*/ _jsxs(Column, {
                        className: styles.textContent,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                weight: "normal",
                                testId: testIds.IntroStepTestIds.WelcomeText(),
                                children: firstName ? t.welcome({
                                    firstName
                                }) : t.welcomeNoName()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h3",
                                fontFamily: "hero",
                                weight: "bold",
                                className: styles.headline,
                                testId: testIds.IntroStepTestIds.Headline(),
                                children: t.headline()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                testId: testIds.IntroStepTestIds.Description(),
                                children: t.description()
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        className: styles.callout,
                        gap: 12,
                        alignItems: "center",
                        testId: testIds.IntroStepTestIds.Callout(),
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                className: styles.calloutIcon,
                                children: /*#__PURE__*/ _jsx(Bulb, {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph2",
                                children: t.callout()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Box, {
                className: styles.videoFrame,
                testId: testIds.IntroStepTestIds.VideoFrame(),
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: VIDEO_THUMBNAIL_URL,
                        alt: t.videoAlt(),
                        className: styles.videoThumbnail
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: styles.playButton,
                        onClick: onPlay,
                        "data-testid": testIds.IntroStepTestIds.PlayButton(),
                        children: /*#__PURE__*/ _jsx(ArrowSolidRight, {
                            size: 48,
                            className: styles.playIcon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                bi: {
                    name: 'skip_vendor_onboarding_intro'
                },
                weight: "normal",
                skin: "primary",
                underline: "none",
                onClick: onSkip,
                testId: testIds.IntroStepTestIds.SkipButton(),
                className: styles.skipButton,
                children: t.skipIntro()
            })
        ]
    });
};
